import ErrorHandler from '_shared/error-handler'
const errorHandler = new ErrorHandler()
export default errorHandler
